import React, {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import Tooltip from '@material-ui/core/Tooltip';
import ManagerService from "../../../../services/ManagerService";
import AgentService from '../../../../services/AgentService';
import EmployerService from "../../../../services/EmployerService";
import {toast} from "react-toastify";
import isEmail from "validator/lib/isEmail";
import InputAdornment from "@material-ui/core/InputAdornment";

const initialUser = {
    name: '',
    surname: '',
    email: '',
    contact_number: '',
    channel_id: '',
    team_id: '',
    position_id: 1,
    manager_id: '',
    agent_code: '',
    agent_type: '',
    aggregator_id: null
}

const AddUserDialog = props => {
    const [user, setUser] = useState(initialUser)
    const [managers, setManagers] = useState([]);
    const {addUserHandler} = props;
    const [open, setOpen] = React.useState(false);
    const [channels, setChannels] = useState([]);
    const [positions, setPositions] = useState([]);
    const [teams, setTeams] = useState([]);
    const [aggregators, setAggregators] = useState([]);
    const [addButton, setAddButton] = useState(false)

    const [nameError, setNameError] = useState(false);
    const [nameErrorMsg, setNameErrorMsg] = useState('');
    const [branchError, setBranchError] = useState(false);
    const [branchErrorMsg, setBranchErrorMsg] = useState('');
    const [lastNameError, setLastNameError] = useState(false);
    const [lastNameErrorMsg, setLastNameErrorMsg] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [emailErrorMsg, setEmailErrorMsg] = useState('');
    const [contactError, setContactError] = useState(false);
    const [contactErrorMsg, setContactErrorMsg] = useState('');
    const [codeError, setCodeError] = useState(false);
    const [codeErrorMsg, setCodeErrorMsg] = useState('');
    const [typeError, setTypeError] = useState(false);
    const [typeErrorMsg, setTypeErrorMsg] = useState('');
    const [teamError, setTeamError] = useState(false);
    const [teamErrorMsg, setTeamErrorMsg] = useState('');
    const [channelError, setChannelError] = useState(false);
    const [channelErrorMsg, setChannelErrorMsg] = useState('');
    const [managerError, setManagerError] = useState(false);
    const [managerErrorMsg, setManagerErrorMsg] = useState('');

    const [error, setError] = useState(false);

    const [switchState, setSwitchState] = React.useState({
        addMultiple: false,
    })

    const handleSwitchChange = name => event => {
        setSwitchState({...switchState, [name]: event.target.checked})
    }

    const resetSwitch = () => {
        setSwitchState({ addMultiple: false })
    }

    const handleClickOpen = () => {
        // console.log("emp id:", props.data.id);
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        resetSwitch()
    }

    const handleAdd = event => {
        //if any field is empty don't submit
        if (user.name === '') {
            setNameError(true)
            setNameErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (user.surname === '') {
            setLastNameError(true)
            setLastNameErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (user.agent_type === '') {
            setTypeError(true)
            setTypeErrorMsg('Select Agent Type')
            setError(true);
            return;
        }
        if (user.agent_code === '') {
            setCodeError(true)
            setCodeErrorMsg('Agent Code is required')
            setError(true);
            return;
        }
        if (user.email === '') {
            setEmailError(true)
            setEmailErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (!isEmail(user.email)) {
            setEmailError(true)
            setEmailErrorMsg('Email not valid')
            setError(true);
            return;
        }
        if (user.contact_number === '') {
            setContactError(true)
            setContactErrorMsg('Contact is required')
            setError(true);
            return;
        }
        if (user.contact_number.length < 9) {
            setContactError(true)
            setContactErrorMsg('Mobile number must be a 9 digit number')
            return;
        }
        if (user.team_id === '') {
            setTeamError(true)
            setTeamErrorMsg('Team field is required')
            setError(true);
            return;
        }
        if (user.manager_id === '') {
            setManagerError(true)
            setManagerErrorMsg('Manager field is required')
            setError(true);
            return;
        }
        if (user.channel_id === '') {
            setChannelError(true)
            setChannelErrorMsg('Channel field is required')
            setError(true);
            return;
        }


        //reset error messages
        setError(false)
        setEmailError(false);
        setNameError(false);
        setLastNameError(false);
        setContactError(false);
        setBranchError(false);
        setTypeError(false);
        setTeamError(false);
        setManagerError(false);
        setChannelError(false);
        setCodeError(false);

        addUserHandler(user)
        setUser(initialUser)
        switchState.addMultiple ? setOpen(true) : setOpen(false)
    }

    const handleChange = name => ({ target: { value } }) => {
        // console.log(name+' '+ value);
        if (name === 'agent_type') {
            setUser({...user, "position_id": 1})
        }
        // validation
        //validate on change
        if (name === 'name' && value === '') {
            setNameError(true)
            setNameErrorMsg('Field is required')
        } else {
            setNameError(false);
            setNameErrorMsg('')
        }
        if (name === 'agent_code' && value === '') {
            setCodeErrorMsg('Field is required')
        } else {
            setCodeErrorMsg('')
        }
        if (name === 'email' && value === '') {
            setEmailError(true)
            setEmailErrorMsg('Field is required')
        } else {
            setEmailError(false)
            setEmailErrorMsg('')
        }
        if (name === 'surname' && value === '') {
            setLastNameError(true)
            setLastNameErrorMsg('Field is required')
        } else {
            setLastNameError(false);
            setLastNameErrorMsg('')
        }

        if (name === 'email' && isEmail(value) === false) {
            setEmailError(true)
            setEmailErrorMsg('Email not valid')
        } else {
            setEmailError(false)
            setEmailErrorMsg('')
        }
        if (name === 'contact_number' && value === '') {
            setContactError(true)
            setContactErrorMsg('Field is required')
        } else {
            setContactError(false)
            setContactErrorMsg('')
        }
        if (name === 'contact_number' && value.length < 9) {
            console.log(value.length < 9);
            setContactError(true)
            setContactErrorMsg('Mobile number must be a 9 digit number')
        } else {
            setContactError(false)
            setContactErrorMsg('')
        }

        setUser({...user, [name]: value})
    }

    useEffect(() => {
        let role_based_perm = JSON.parse(localStorage.getItem('role_based_permissions'));
        let direct_perm = JSON.parse(localStorage.getItem('direct_permissions'));
        console.log("role_based: ", role_based_perm);
        console.log("direct perm: ", direct_perm);
        if (role_based_perm === null || role_based_perm === undefined) {
            setAddButton(false);
        } else {
            role_based_perm.map((perm, i) => {
                if (perm.name === 'add agents') {
                    setAddButton(true);
                }
            })
        }
        if (direct_perm === null || direct_perm === undefined) {
            setAddButton(false);
        } else {
            direct_perm.map((perm, i) => {
                if (perm.name === 'add agents') {
                    setAddButton(true);
                }
            })
        }
        ManagerService.getAllManagers().then(response => {
            console.log(response);
            console.log(response.data);
            if (response.status === undefined) {
                setManagers([])
            } else {
                setManagers(response.data.managers);
            }

        }).catch(err => {
            console.log(err);
            setManagers([])
        });
        AgentService.getAllTeams().then(response => {
            console.log(response);
            if (response === undefined) {
                setTeams([])
            }
            let teams = response.teams;
            setTeams(teams);

            //   console.log();                                                                                        );
        }).catch(err => {
            console.log(err);
            setTeams([])
        });
        AgentService.getAllChannels().then(response => {
            console.log(response);
            if (response === undefined) {
                setChannels([])
            }
            let channels = response.channels;
            setChannels(channels);

        }).catch(err => {
            console.log(err);
            setChannels([])
        });
        AgentService.getAllPositions().then(response => {
            console.log(response);
            if (response === undefined) {
                setPositions([])
            }
            let positions = response.positions;
            setPositions(positions);

            //   console.log();                                                                                        );
        }).catch(err => {
            console.log(err);
            setPositions([])
        });
        let token = JSON.parse(localStorage.getItem('token'));

        console.log("token", token)
        EmployerService.getAllEmployers().then(response => {
            console.log('aggr', response);
            if (response !== null || response !== undefined) {
                setAggregators(response);
            } else if (response.status === 401) {
                setAggregators([])
            } else {
                setAggregators([])
            }
        }).catch(err => {
            setAggregators([])
            console.log(err);
            toast.warning('Failed to get all aggregators')
        });

    }, []);

    return (
        <div>
            {addButton && (
                <Tooltip title="Add New">
                <span className="btn btn-sm btn-primary mr-5" onClick={handleClickOpen}>
                    <i className="fa fa-plus-square"/> &nbsp;&nbsp;Add Agent
                </span>
                </Tooltip>
            )}
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Add Agent</DialogTitle>
                <DialogContent>
                    <DialogContentText>Please fill in details</DialogContentText>
                    {error && (
                        <small className="text-danger">Make sure every field is filled in.</small>
                    )}
                    <TextField
                        error={nameError}
                        helperText={nameErrorMsg}
                        required
                        autoFocus
                        margin="dense"
                        label="FirstName"
                        type="text"
                        fullWidth
                        value={user.name}
                        inputProps={{style: {textTransform: 'capitalize'}}}
                        onChange={handleChange('name')}
                    />
                    <TextField
                        error={lastNameError}
                        helperText={lastNameErrorMsg}
                        required
                        margin="dense"
                        label="LastName"
                        type="text"
                        fullWidth
                        value={user.surname}
                        inputProps={{style: {textTransform: 'capitalize'}}}
                        onChange={handleChange('surname')}
                    />

                    <TextField
                        error={emailError}
                        helperText={emailErrorMsg}
                        required
                        margin="dense"
                        label="Email"
                        type="email"
                        fullWidth
                        inputProps={{style: {textTransform: 'lowercase'}}}
                        value={user.email}
                        onChange={handleChange('email')}
                    />
                    <TextField
                        error={codeError}
                        helperText={codeErrorMsg}
                        required
                        margin="dense"
                        label="Agent Code"
                        type="text"
                        fullWidth
                        value={user.agent_code}
                        onChange={handleChange('agent_code')}
                    />

                    <TextField
                        error={contactError}
                        helperText={contactErrorMsg}
                        required
                        margin="dense"
                        label="Contact Number"
                        type="number"
                        fullWidth
                        value={user.contact_number}
                        onChange={handleChange('contact_number')}
                        onInput={(e) => {
                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 9)
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">
                                +263
                            </InputAdornment>
                        }}
                    />

                    <label>Agent Type</label>
                    <Select className="form-control" onChange={handleChange('agent_type')} name="agent_type">
                        <option disabled={true} value>Select Agent Type</option>
                        <option value='TIED'>Tied</option>
                        <option value='EXECUTIVE'>Executive</option>
                        <option value="CDA">Client Delight Assistant</option>
                    </Select>
                    {typeError && (
                        <span className="text-danger">{typeErrorMsg}</span>
                    )}
                    <br/>
                    <label>Channel</label>
                    <Select className="form-control" onChange={handleChange('channel_id')} name="channel_id">
                        <option disabled={true} value>Select Channel</option>
                        {channels.map((channel, i) => {
                            return (
                                <option key={i} value={channel.id}
                                        channel_id={channel.id}>{channel.channelTitle}</option>

                            )
                        })}
                    </Select>
                    {channelError && (
                        <span className="text-danger">{channelErrorMsg}</span>
                    )}
                    <br/>
                    <label>Team</label>
                    <Select margin="dense" className="form-control" onChange={handleChange('team_id')} name="team_id">
                        <option disabled={true} value>Select Team</option>
                        {teams.map((team, i) => {
                            return (
                                <option key={i} value={team.id} team_id={team.id}>{team.teamTitle}</option>

                            )
                        })}
                    </Select>
                    {teamError && (
                        <span className="text-danger">{teamErrorMsg}</span>
                    )}
                    <br/>
                    <label>Manager</label>
                    <Select className="form-control" onChange={handleChange('manager_id')} name="manager_id">
                        <option value disabled>Select Manager</option>
                        {managers.map((a, i) => {
                            return (
                                <option key={i} value={a.id}>{a.name} {a.surname}</option>
                            )
                        })}

                    </Select>
                    {managerError && (
                        <span className="text-danger">{managerErrorMsg}</span>
                    )}
                    <br/>
                    <label>Aggregator</label>
                    <Select className="form-control" onChange={handleChange('aggregator_id')} name="aggregator_id">
                        <option disabled={true} value>Select Aggregator</option>
                        {aggregators.map((aggregator, i) => {
                            return (
                                <option key={i} value={aggregator.id}>{aggregator.name}</option>
                            )
                        })}
                    </Select>
                </DialogContent>
                <DialogActions>
                    <Tooltip title="Add multiple">
                        <Switch
                            checked={switchState.addMultiple}
                            onChange={handleSwitchChange('addMultiple')}
                            value="addMultiple"
                            inputProps={{'aria-label': 'secondary checkbox'}}
                        />
                    </Tooltip>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleAdd} color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

AddUserDialog.propTypes = {
    addUserHandler: PropTypes.func.isRequired,
}

export default AddUserDialog;
